module.exports = __webpack_public_path__ + "img/welcome-icon.1697b2bc.png";